import baseGetTag from "./_baseGetTag.js";
import getPrototype from "./_getPrototype.js";
import isObjectLike from "./isObjectLike.js";
var objectTag = "[object Object]", funcProto = Function.prototype, objectProto = Object.prototype, funcToString = funcProto.toString, hasOwnProperty = objectProto.hasOwnProperty, objectCtorString = funcToString.call(Object);
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag)
    return !1;
  var proto = getPrototype(value);
  if (proto === null)
    return !0;
  var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
export {
  isPlainObject as default
};
//# sourceMappingURL=isPlainObject.js.map
